import SummaryApi from "../common";
import { toast } from "react-toastify";

const addToCart = async (e, id) => {
  e?.preventDefault();
  e?.stopPropagation();

  try {
    const response = await fetch(SummaryApi.addToCartProduct.url, {
      method: SummaryApi.addToCartProduct.method,
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ productId: id })
    });

    // ---------- GUEST USER ----------
    if (response.status === 401) {
      let cart = JSON.parse(localStorage.getItem("guest_cart") || "[]");

      // always store plain productId
      if (!cart.includes(id)) {
        cart.push(id);
        localStorage.setItem("guest_cart", JSON.stringify(cart));
        window.dispatchEvent(new Event("guest_cart_changed"));
        toast.success("Added to cart");
      } else {
        toast.info("Already in cart");
      }

      return { success: true, guest: true };
    }

    // ---------- LOGGED IN ----------
    const data = await response.json();

    if (!data.success) {
      toast.error(data.message || "Unable to add to cart");
      return data;
    }

    toast.success(data.message || "Added to cart");
    return data;

  } catch (err) {
    //console.error(err);
    toast.error("Something went wrong");
  }
};

export default addToCart;
